import { jsPDF } from "jspdf";
import moment from "moment";
import DownloadManager from "./download.js";
import {Loading} from "element-ui";

function splitHtmlOut(htmlStr) {
  if (htmlStr.indexOf("<") < 0 || htmlStr.indexOf("</") < 0) {
    return htmlStr;
  }
  let pattern = "</p>";
  let myHtmlStr = htmlStr;
  let firstPatternArray = ["<p", "<div"];
  let lastPatternArray = ["</p>", "</div>"];
  for (let i = 0; i < lastPatternArray.length; i++) {
    let lastPattern = lastPatternArray[i];
    let firstPattern = firstPatternArray[i];
    if (myHtmlStr.indexOf(lastPattern) >= 0) {
      let tmpArray = myHtmlStr.split(lastPattern);
      myHtmlStr = "";
      for (let j = 0; j < tmpArray.length; j++) {
        if (tmpArray[j].length > 0) {
          myHtmlStr += tmpArray[j];
        }
      }
      while (myHtmlStr.indexOf(firstPattern) >= 0) {
        let index = myHtmlStr.indexOf(firstPattern);
        let index2 = myHtmlStr.indexOf(">");
        let subString = myHtmlStr.substring(index, index2+1);
        myHtmlStr = myHtmlStr.replace(subString, "");
      }
    }
  }
  return myHtmlStr;
}


function rotateImage(img) {
  let cas = document.createElement("canvas");
  cas.width = img.height;
  cas.height = img.width;
  let context = cas.getContext("2d");
  context.fillStyle = "#ffffff";
  context.fillRect(0,0,cas.width, cas.height);
  context.rotate(Math.PI * 0.5);
  context.drawImage(img, 0, -img.height, img.width, img.height);
  return cas.toDataURL("image/jpeg", 1.0);
}

function convertToJPEG(img) {
  let cas = document.createElement("canvas");
  cas.width = img.width;
  cas.height = img.height;
  let context = cas.getContext("2d");
  context.fillStyle = "#ffffff";
  context.fillRect(0,0,cas.width, cas.height);
  context.drawImage(img, 0, 0,);
  return cas.toDataURL("image/jpeg", 1.0);
}

//通过url获取指定图片
function getImageFromUrl(url, callback, failure) {
    var img = new Image();
    img.onError = function() {
        failure();
    };
    img.onload = function() {
      callback(img);
    };
    img.src = url;
}



function downLoadImagesOneByOne(images, sucessblack, completionHandler) {
  if (images == null || images.length == 0) {
    completionHandler();
    return;
  }
  let first = images[0];
  let newImages = [];
  if (images.length > 1) {
     newImages = images.slice(1);
  }

  DownloadManager.getBlob(first).then(function (img) {
    let a = new FileReader();
    a.onload = function (e) {
      getImageFromUrl(e.target.result, function(res) {
        sucessblack(res, e.target.result);
        setTimeout(function() {
          downLoadImagesOneByOne(newImages, sucessblack, completionHandler);
        }, 50);
      }, function() {
        downLoadImagesOneByOne(newImages, sucessblack, completionHandler);
      });
    };
    a.readAsDataURL(img);
    return;
  }).catch(function (status) {
    downLoadImagesOneByOne(newImages, sucessblack, completionHandler);
  });
}

function readBlobAsDataURL(blob, callback) {
    var a = new FileReader();
    a.onload = function(e) {callback(e.target.result);};
    a.readAsDataURL(blob);
}

function saveToPdf(params, callback) {
  let user = params.user;
  let fileName = params.fileName;
  let a4Width = 595.28;
  let a4Height = 841.89;
  let doc = new jsPDF("p", "pt", [a4Width, a4Height]);

  doc.setFont("simsun", "normal");

  doc.setFontSize(12);
  doc.text("会员编号：___________________" , 90, 92);

   doc.setFontSize(22);
   doc.text("上海市篮球协会", 297.64, 270, "center");
   doc.text("第十一届团体会员", 297.64, 330, "center");
   doc.text("入会申请书", 297.64, 387, "center");

   doc.setFontSize(14);

   doc.setLineWidth(0.6);
   doc.line(225, 749, 500, 749, "S");

   doc.line(225, 698, 500, 698, "S");

   doc.text("团体会员名称：", 120, 698);

   let name = user.name;
   doc.text(name, 335, 698, "center");

   doc.text("填 表 日 期：", 120, 749);

   let dateString = moment().format("yyyy年MM月DD日");
   doc.text(dateString, 335, 749, "center");

   doc.addPage();
   let lineHeight = 14;
   let lineMargin = 16;
   let notice = "";
   let originY = 100;
   doc.text("填表说明", 90, originY);

   originY += (lineHeight + lineMargin);
   doc.text("1.登记表需如实填写。", 90, originY);

   originY += (lineHeight + lineMargin);
   doc.text("2.单位名称：填写单位全称。", 90, originY);

   originY += (lineHeight + lineMargin);
   doc.text("3.会员代表：企业单位会员代表需是单位董事长或总经理，学校及\r社会组织单位会员代表需是单位负责人。", 90, originY);

   originY += (lineHeight * 2 + lineMargin);
   doc.text("4.企业单位会员需提供营业执照副本复印件（加盖单位公章），学\r校及社会组织单位会员需提供法人登记证书副本复印件（加盖单位\r公章）。", 90, originY);

   doc.setFont("sun", "bold");
   doc.setFontSize(16);



   doc.addPage();
   let topPageY = 100;

   doc.text("入 会 申 请", 297.64, topPageY, "center");

   doc.setFont("simsun", "normal");
   doc.setLineHeightFactor(1.20);
   doc.setCharSpace(0.35);
   doc.setFontSize(14);
   topPageY += 62;
   // 上海市篮球协会：
   doc.text("上海市篮球协会：", 90, topPageY);
   topPageY += 38
   //39
   let label = "    我单位已阅读和充分了解《上海市篮球协会章程》的有关规\r定，愿意成为上海市篮球协会的会员。我单位将拥护协会章程，遵\r守协会相关规定，执行协会决议，维护协会合法权益和声誉；参加\r协会组织的活动，支持协会工作；按规定缴纳会费，履行会员义\r务。特申请加入协会，请予批准。\r    我单位郑重承诺：提供的所有信息真实、准确、完整。";
   doc.text(label, 90, topPageY);

   topPageY += 16 * 6;
   topPageY += 108
    //法定代表人签字：
   doc.text("法定代表人签字：", 301, topPageY);

   topPageY += 40;
   doc.text("单位公章", 301, topPageY);

   topPageY += 40;
   doc.text("年    月    日", 408, topPageY);

    doc.addPage();

    doc.text("附件一：", 50, 72);

    doc.setFont("sun", "bold");
    doc.setFontSize(18);
    doc.text("上海市篮球协会第十一届团体会员申请登记表", 297.64, 100, "center");
    let lineWith = 0.6;
    doc.setLineWidth(lineWith);
    let firstColumnWidth = 65;
    let secondColumnWidth = 125;
    let thirdColumnWidth = 63;
    let forthColumnWidth = 130;

    lineHeight = 45;
    let maxLineHeight = 160;
    let lastLineHeight = 115;

    let rectWith = 5 * lineWith + firstColumnWidth + secondColumnWidth + thirdColumnWidth + forthColumnWidth;
    let rectHeight = 10 * lineWith + 7 * lineHeight + maxLineHeight + lastLineHeight;
    let minX = (a4Width - rectWith) * 0.5;
    let minY = 139;
    let maxY = rectHeight + minY;
    let maxX = minX + rectWith;
    doc.rect(minX, minY, rectWith, rectHeight);

    doc.line(minX + firstColumnWidth, minY, minX + firstColumnWidth, maxY, "S");

    for(let i = 0; i < 7; i++) {
      let lineY = (i + 1) * (lineHeight + lineWith) + minY;
      doc.line(minX, lineY, maxX, lineY, "S");
    }
    doc.line(minX, maxY - lastLineHeight - lineWith, maxX, maxY - lastLineHeight - lineWith, "S");

    let tmpX1 = minX + lineWith * 2 + firstColumnWidth + secondColumnWidth;
    let tmpY1 = minY + lineWith + lineHeight;
    let tmpY2 = tmpY1 + lineHeight + lineWith;
    doc.line(tmpX1, tmpY1, tmpX1, tmpY2, "S");

    tmpY1 = minY + lineWith * 4 + lineHeight * 4;
    tmpY2 = tmpY1 + (lineHeight + lineWith) * 2;
    doc.line(tmpX1, tmpY1, tmpX1, tmpY2, "S");


    tmpX1 = minX + lineWith * 3 + firstColumnWidth + secondColumnWidth + thirdColumnWidth;
    doc.line(tmpX1, tmpY1, tmpX1, tmpY2, "S");

    tmpY1 = minY + lineWith + lineHeight;
    tmpY2 = tmpY1 + lineHeight + lineWith;
    doc.line(tmpX1, tmpY1, tmpX1, tmpY2, "S");

    // doc.setFont("sun", "bold");
    doc.setFontSize(12);

    let fontHeight = 12;
    let offsetY = -3;
    let row = 0;
    let thirdColumnX = minX + (firstColumnWidth + secondColumnWidth) + lineWith * 3 + thirdColumnWidth * 0.5;

    tmpX1 = minX + firstColumnWidth * 0.5 + lineWith;
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text("单位名称", tmpX1, tmpY1, "center");


    row += 1;
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    doc.text("法定代表\r人", tmpX1, tmpY1, "center");

    doc.text("统一\r信用代码", thirdColumnX, tmpY1, "center");

    row += 1;
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text("注册时间", tmpX1, tmpY1, "center");

    row += 1;
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text("单位地址", tmpX1, tmpY1, "center");

    row += 1;
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text("会员代表", tmpX1, tmpY1, "center");

    doc.text("联系电话", thirdColumnX, tmpY1, "center");

    row += 1;
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text("联系人", tmpX1, tmpY1, "center");

    doc.text("联系电话", thirdColumnX, tmpY1, "center");

    row += 1;
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text("电子邮箱", tmpX1, tmpY1, "center");


    row += 1;
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * row + maxLineHeight * 0.5 + offsetY;
    doc.text("单位情\r况介绍", tmpX1, tmpY1, "center");

    let sealX = minX + lineWith * 2 + firstColumnWidth + 170;
    let sealY = tmpY1 + maxLineHeight * 0.5 - 27;
    doc.text("企业盖章", sealX, sealY, "left");

    let dateX = minX + lineWith * 2 + firstColumnWidth + 107;
    let dateY = tmpY1 + maxLineHeight * 0.5 - 9;
    doc.text("年    月    日", sealX, dateY, "left");

    row += 1;
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row - 1) + maxLineHeight + lastLineHeight * 0.5 + offsetY;
    tmpY1 -= fontHeight;
    doc.text("审\r核\r意\r见", tmpX1, tmpY1, "center");

    row = 0;
    doc.setFont("simsun", "normal");
    let marginX = 10;
    fontHeight = 13;
    tmpX1 = minX + lineWith * 2 + firstColumnWidth + marginX;
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text(name, tmpX1, tmpY1, "left");

    row += 1;
    let legalPerson = user.legalPerson;
    // legalPerson = "董砾";
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text(legalPerson, tmpX1, tmpY1, "left");

    let forthColumnX = minX + lineWith * 4 + firstColumnWidth + secondColumnWidth + thirdColumnWidth + marginX;

    let idNumber = user.idNumber;
    // idNumber = "9135052155323005XL";
    doc.text(idNumber, forthColumnX, tmpY1, "left");

    row += 1;
    let foundedDate = user.foundedDate;
    let foundedDateString = moment(foundedDate).format("yyyy年MM月DD日");
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text(foundedDateString, tmpX1, tmpY1, "left");

    row += 1;
    let nativePlace = user.nativePlace;
    // nativePlace = "上海市杨浦区伟成路70号1号楼803";
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text(nativePlace, tmpX1, tmpY1, "left");

    row += 1;
    let memberPerson = user.memberPerson;
    // memberPerson = "厉进虎";
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text(memberPerson, tmpX1, tmpY1, "left");

    let mobile = user.mobile;
    // mobile = "17301781425";
    doc.text(mobile, forthColumnX, tmpY1, "left");

    row += 1;
    let contacts = user.contacts;
    // contacts = "厉进虎";
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text(contacts, tmpX1, tmpY1, "left");

    let tel = user.tel;
    // tel = "17301781425";
    doc.text(tel, forthColumnX, tmpY1, "left");

    row += 1;
    let email = user.email;
    // email = "lambert2048@163.com";
    tmpY1 = minY + lineWith * (row + 1) + lineHeight * (row + 0.5) + offsetY;
    tmpY1 += fontHeight * 0.5;
    doc.text(email, tmpX1, tmpY1, "left");

    row += 1;
    let desc = user.desc;
    if (desc != null && desc.length > 0) {
      desc = splitHtmlOut(desc);
    }
    let maxWidth = maxY - lineWith - 15 - tmpX1;
    maxWidth = 300;
    let linesArray = doc.splitTextToSize(desc, maxWidth);

    tmpY1 = minY + lineWith * (row + 1) + lineHeight * row + offsetY;
    if (linesArray.length > 7) {
      linesArray = linesArray.splice(0, 7);

      let lastItem = linesArray[linesArray.length - 1];
      lastItem = lastItem.substring(0, lastItem.length - 3);
      lastItem += "...";
      linesArray[linesArray.length - 1] = lastItem;
    }
    if (linesArray.length > 1) {
      tmpY1 += fontHeight;
    } else {
      tmpY1 += fontHeight * 0.5;
    }
    tmpY1 += 10;

    doc.text(linesArray, tmpX1, tmpY1, "left");
    let license = user.license;
    // console.log(license);
    if (license != null && license.length > 0) {
      // console.log('有团体证件！');
      let imageArray = license.split(",");
      let dealWithImageSuccess = function(image, dataUrl) {
        let imageData = dataUrl;
        doc.addPage();
        let imageMargin = 30;
        let imageWidth = image.width;
        let imageHeight = image.height;
        let maxImageWidth = a4Width - imageMargin * 2;
        let maxImageHeight = a4Height - imageMargin * 2;
        let image_x = imageMargin;
        let image_y = imageMargin;
        let ratated = false;
        if (imageWidth > imageHeight && imageWidth > maxImageHeight) {
          // console.log('需要旋转');
          let tmp = imageWidth;
          imageWidth = imageHeight;
          imageHeight = tmp;
          ratated = true;
        } else {
          // console.log('不需要旋转！');
          // console.log(dataUrl);
        }

        let ratioWidth = maxImageWidth / imageWidth;
        let ratioHeight = maxImageHeight / imageHeight;

        let minRatio = ratioWidth <= ratioHeight ? ratioWidth : ratioHeight;
        if (minRatio < 1) {
          imageWidth = Math.floor(imageWidth * minRatio);
          imageHeight = Math.floor(imageHeight * minRatio)
        }

        image_x = Math.round((maxImageWidth - imageWidth) / 2 + imageMargin);
        image_y = Math.round((maxImageHeight - imageHeight) / 2 + imageMargin);

        // console.log("( x: " + image_x + ", y: " + image_y + ", width: " + imageWidth + ", height: " + imageHeight + " )")

        if (ratated) {
          imageData = rotateImage(image);
        } else {
          let format = null;
          if (typeof imageData == 'string') {
            let tmpArray = imageData.split(";base64");
            let extension = tmpArray[0].split("image/")[1];
            if (extension) {
              format = extension.toUpperCase();
            }
          }
          if (format != "JPEG") {
            imageData = convertToJPEG(image);
          }
        }

        doc.addImage({
          imageData,
          x: image_x,
          y: image_y,
          width: imageWidth,
          height: imageHeight
        });
      };

      downLoadImagesOneByOne(imageArray, dealWithImageSuccess, function() {
        doc.save(fileName);
        callback();
      });
    } else {
      doc.save(fileName);
      callback();
    }
}


export default {
  convertToPdf: function (params, success, failure) {
    if (this.normalLoadSuccess && this.boldLoadSuccess) { // 两个字体均已下载完
      if (this.showLoading) {
        this.showLoading = false;
      }
      saveToPdf(params, success);
      return;
    }
    let code = 0;
    if (this.normalLoadError || this.boldLoadError) { // 字体下载出现错误
      code = 1; // 表示字体集下载出错
      failure(code);
      return;
    }

    // 下载中
    if (!this.showLoading) {
      this.showLoading = true;
    }
    let self = this;
    setTimeout(function () {
      self.convertToPdf(params, success, failure);
    }, 200);
  },

  normalLoadSuccess: false,
  normalLoadError: false,

  boldLoadSuccess: false,
  boldLoadError: false,

  showLoading: false,
  loadingFlag: null,

  loadNormalFontSuccess: function (event) {
    this.normalLoadError = false;
    this.normalLoadSuccess = true;
    this.config.normalFont();
    console.log('normal font config success');
  },
  loadNormalFontError: function (event) {
    this.normalLoadError = true;
  },
  loadBoldFontSuccess: function (event) {
    this.boldLoadError = false;
    this.boldLoadSuccess = true;
    this.config.boldFont();
    console.log('bold font config success');
  },

  loadBoldFontError: function (event) {
    this.boldLoadError = true;
  },

  config: {
    boldFont: function() {
      let boldFont = getSimsunBoldFont();
      var callAddBoldFont = function () {
        this.addFileToVFS('sun-bold.ttf', boldFont);
        this.addFont('sun-bold.ttf', 'sun', 'bold');
      };
      jsPDF.API.events.push(['addFonts', callAddBoldFont]);
    },
    normalFont: function() {
      let normalFont = getSimsunNormalFont();
      var callAddNormalFont = function () {
      this.addFileToVFS('simsun-normal.ttf', normalFont);
      this.addFont('simsun-normal.ttf', 'simsun', 'normal');
      };
      jsPDF.API.events.push(['addFonts', callAddNormalFont])
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/pdf-manager.js